module.exports = __webpack_public_path__ + "static/media/aauxnext-bd.f9a5b6bb.woff2";